export default __webpack_public_path__ + "static/media/YellowRegular.b1ec51c6.png";